import request from '@/axios'


export function createTag (payload, platform_customer_id) {
  return request({
    url:`/tag/create/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}

export function fetchingTag (platform_customer_id, payload = null) {
  return request({
    url:`/tag/all/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}


export function deletingTag (platform_customer_id, tag_id) {
  return request({
    url:`/tag/delete/${platform_customer_id}/${tag_id}`,
    method:'POST'
  })
}

export function fetchModule () {
  
  return request({
    url:'/tag/module-list',
    method:'GET'
  })
}

export function attachTagInAssignment (platform_customer_id, payload) {
  
  return request({
    url:`/assignment-builder/attach-tag/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}

export function attachTagInCourse (platform_customer_id, payload) {
  
  return request({
    url:`/course/attach-tag/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}

export function attachTagInCRM (platform_customer_id, payload) {
  
  return request({
    url:`/leads/tag/attach/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}
export function attachTagInClient (platform_customer_id, payload) {
  
  return request({
    url:`/clientUser/tag/attach/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}
export function attachTagInStaff (platform_customer_id, payload) {
  
  return request({
    url:`/operationalUser/tag/attach/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}